export * from './collapsible.component';
export * from './collapse.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/collapsible/index.ts